import { API, PortalItem } from "@thenounproject/lingo-core";
import { createQueryAction } from "../actionCreators";

type Args = {
  portalItemId: string | number;
  assetToken?: string;
};

const [usePortalItem, fetchPortalItem] = createQueryAction<Args, PortalItem, string>(
  {
    entity: "portalItems",
    action: "fetch",
    denormalize: {
      entity: null,
      portalItems: {
        entity: "portalItems",
        asset: "assets",
      },
    },
    condition: ({ args }) => Boolean(args.portalItemId),
  },
  async ({ args }) => {
    const res = await API.call<{ portalItem: string }>({
      endpoint: `portal_items/${args.portalItemId}`,
      method: "GET",
      query: {
        asset_token: args.assetToken,
      },
    });
    return { ...res, result: res.result.portalItem };
  }
);

export default usePortalItem;
export { fetchPortalItem };
